import { useState, useEffect } from 'react';

// project imports
import { NETWORK_2G, NETWORK_3G, NETWORK_SLOW_2G, OFFLINE, ONLINE } from '../constants';

export function useNetwork() {
    const getNetworkDetails = () => {
        try {
            // Check if entirely offline
            if (!navigator.onLine) {
                return { online: false, isSlow: false, isGood: false };
            }

            // Check for Network Information API support
            const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

            if (connection) {
                const { effectiveType } = connection;
                // Triggers 'slow' for slow-2g, 2g, and 3g connections
                if (effectiveType === NETWORK_SLOW_2G || effectiveType === NETWORK_2G || effectiveType === NETWORK_3G) {
                    return { online: true, isSlow: true, isGood: false };
                }
            }

            // Proper/Fast connection (4G, 5G, Wi-Fi, or unsupported browsers)
            return { online: true, isSlow: false, isGood: true };
        } catch (error) {
            console.log("28 : useNetwork : Error while getting network detail", error);
        }
    };

    // State initialization
    const [networkState, setNetworkState] = useState(getNetworkDetails);

    useEffect(() => {
        const updateNetwork = () => setNetworkState(getNetworkDetails());
        const handleOffline = () => setNetworkState({ online: false, isSlow: false, isGood: false });

        window.addEventListener(ONLINE, updateNetwork);
        window.addEventListener(OFFLINE, handleOffline);

        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        if (connection) {
            connection.addEventListener('change', updateNetwork);
        }

        return () => {
            window.removeEventListener(ONLINE, updateNetwork);
            window.removeEventListener(OFFLINE, handleOffline);
            if (connection) {
                connection.removeEventListener('change', updateNetwork);
            }
        };
    }, []);

    return networkState;
}
